var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrosshairWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.244 0.577452C12.5694 0.252015 13.0971 0.252015 13.4225 0.577452C13.7479 0.902889 13.7479 1.43053 13.4225 1.75596L8.17843 7.00004L13.4225 12.2441C13.7479 12.5696 13.7479 13.0972 13.4225 13.4226C13.0971 13.7481 12.5694 13.7481 12.244 13.4226L6.99992 8.17855L1.75584 13.4226C1.4304 13.7481 0.902767 13.7481 0.57733 13.4226C0.251893 13.0972 0.251893 12.5696 0.57733 12.2441L5.82141 7.00004L0.57733 1.75596C0.251893 1.43053 0.251893 0.902889 0.57733 0.577452C0.902767 0.252015 1.4304 0.252015 1.75584 0.577452L6.99992 5.82153L12.244 0.577452Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshairWhite);
export default __webpack_public_path__ + "static/media/crosshair-white.21593818.svg";
export { ForwardRef as ReactComponent };